/**
 * De quem é uma tecla na área de trabalho do Modo PC — F138.
 *
 * Várias telas escutam o teclado da página ao mesmo tempo (`useScopedKeydown`),
 * e cada janela precisa responder, para cada tecla, "é minha?". A regra:
 *
 * - só a janela **ativa** trata tecla;
 * - dentro dela, sim;
 * - fora de QUALQUER janela — o foco no corpo da página, na barra de tarefas,
 *   num diálogo que ainda cobre a página inteira —, também: é a ativa que está
 *   na frente de quem digita;
 * - dentro de OUTRA janela, não, mesmo que esta seja a ativa por um instante.
 *
 * Função pura, para testar sem montar janela nenhuma.
 */
export const windowOwnsKey = ({
  active,
  frame,
  target,
}: {
  readonly active: boolean
  readonly frame: Element | null
  readonly target: EventTarget | null
}): boolean => {
  if (!active || frame === null) return false
  if (target instanceof Node && frame.contains(target)) return true
  return !(
    target instanceof Element &&
    target.closest('[data-desktop-window]') !== null
  )
}
